<!-- <ng-template  #modal let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{modalConfig.modalTitle}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>Hello, World!</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="c('Save click')">Save</button>
    </div>
  </ng-template> -->
<ng-template #modal>

    <div class="modal-header">
        <div> 
            <button type="button" class="btn close" aria-label="Close" (click)="close()">
                <i class="icon-cross"></i>
            </button>

        </div>
        <div>
            <h5 class="modal-title w-100">{{ modalConfig.modalTitle }}</h5>
           <!--  <div class="modal-subtitle" [innerHTML]="modalConfig.modalSubTitle"></div> -->
            <p class="modal-subtitle" [innerHTML]="modalConfig.modalSubTitle"></p>
            <p class="modal-subtext">{{modalConfig.modalText}}</p>
        </div>


    </div>

    <div class="modal-body">
        <ng-content></ng-content>
    </div>
  <!--   <div class="modal-footer">
        <button type="button" class="btn btnModalConfirm" (click)="dismiss()"
            *ngIf="modalConfig.hideDismissButton === undefined || !modalConfig.hideDismissButton()"
            [disabled]="modalConfig.disableDismissButton !== undefined && modalConfig.disableDismissButton()">
            {{ modalConfig.dismissButtonLabel }}
        </button>
        <button type="button" class="btn btn-outline-primary" (click)="close()"
            *ngIf="modalConfig.hideCloseButton === undefined || !modalConfig.hideCloseButton()"
            [disabled]="modalConfig.disableCloseButton !== undefined && modalConfig.disableCloseButton()">
            {{ modalConfig.closeButtonLabel }}
        </button>
    </div> -->
</ng-template>